import { requests } from './baseServices'

export const ClientServices = {    
    getAll: (criteria) => requests.get('api/clients', criteria),
    getAllWithOptions: (criteria) => requests.post('api/clients/filtered', criteria),
    getById: (id) => requests.get(`api/clients/${id}`),
    update: (id, template) => requests.put(`api/clients/${id}`, template),
    create: (template) => requests.post(`api/clients`, template),
    duplicate: (id) => requests.post(`api/clients/duplicate/${id}`),
    delete: (id) => requests.delete(`api/clients/${id}`),
    search: (query) => requests.get('api/clients/search', { query: query }),
};